import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../../../../components/AccountContext';
import SurveyList from './SurveyProjectSurveyList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query surveys(
    $accountId: ID!
    $surveyProjectId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: SurveyFilter
    $sort: SurveySortSpecifier
  ) {
    account(id: $accountId) {
      id
      surveyProject(id: $surveyProjectId) {
        id
        surveys(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
          totalCount
          indexFrom
          indexTo
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          edges {
            cursor
            node {
              id
              name
              createdOn
              statuses
              self {
                id
                respondent {
                  id
                  firstName
                  lastName
                  locale
                }
              }
              template {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

class SurveyProjectSurveyListContainer extends Component {
  render() {
    const {
      currentAccount, location, translatedTags, match,
      trackSurvey, trackingSurvey,
    } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);

    const { surveyProjectId } = match.params;

    const variables = {
      ...pagination,
      surveyProjectId,
      accountId: currentAccount,
      sort: params.sort,
      filter: params.filter,
    };
    return (
      <Query query={LIST_QUERY} variables={variables}>
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = (data && data.account && data.account.surveyProject)
            ? data.account.surveyProject.surveys
            : emptyConnection();

          return (
            <SurveyList
              connection={connection}
              currentAccount={currentAccount}
              translatedTags={translatedTags}
              loading={loading}
              trackSurvey={trackSurvey}
              trackingSurvey={trackingSurvey}
            />
          );
        }}
      </Query>
    );
  }
}

SurveyProjectSurveyListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  trackSurvey: PropTypes.func.isRequired,
  trackingSurvey: PropTypes.string,
};

SurveyProjectSurveyListContainer.defaultProps = {
  trackingSurvey: null,
};

const mapState = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapState,
      null,
    )(withAccount(SurveyProjectSurveyListContainer)),
  ),
);
